// extracted by mini-css-extract-plugin
export var circle = "_fz-1";
export var exitConfirmationModal = "_fz-5";
export var iframe = "_fz-0";
export var offline = "_fz-3";
export var online = "_fz-2";
export var workstationSelectError = "_fz-4";